import { useCallback } from 'react';
import { Capacitor } from '@capacitor/core';
import {
	AndroidSettings,
	IOSSettings,
	NativeSettings,
} from 'capacitor-native-settings';

export interface IUseOpenAppSettings {
	/** True when running inside a native (iOS/Android) shell */
	isNativePlatform: boolean;
	/** Open the app's native settings screen (no-op on web) */
	openAppSettings: () => void;
}

/**
 * Opens the OS-level app settings so the user can re-grant a permission
 * that was previously denied.
 */
export const useOpenAppSettings = (): IUseOpenAppSettings => {
	const isNativePlatform = Capacitor.isNativePlatform();

	const openAppSettings = useCallback(() => {
		if (!isNativePlatform) return;

		NativeSettings.open({
			optionAndroid: AndroidSettings.ApplicationDetails,
			optionIOS: IOSSettings.App,
		});
	}, [isNativePlatform]);

	return { isNativePlatform, openAppSettings };
};
